module.exports = __webpack_public_path__ + "img/962d9ea.png";